import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    borderRadius: '16px !important',
    maxWidth: '400px !important',
    margin: '16px',
    backgroundColor: '#000000',
    color: 'var(--text-color)',
    padding: 0,
  },

  dialogContent: {
    textAlign: 'center',
    backgroundColor: 'transparent',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',

    '& $rankNumber': {
      fontSize: '22px ',
      fontWeight: '700',
      color: '#f66000 ',
      lineHeight: '1',
    },

    '& $date': {
      fontSize: '14px',
      color: '#888888',
      margin: '10px',
    },

    '& $rankDescription': {
      fontSize: '18px',
      color: 'var(--text-color)',
      textAlign: 'center',
      lineHeight: '1.4',
      fontWeight: '700',
    },

    '& $podcastTitle': {
      fontSize: '24px',
      fontWeight: 'bold',
      color: 'var(--text-color)',
      textAlign: 'center',
      lineHeight: '1.2',
      maxWidth: '300px',
    },

    '& $podcastArtist': {
      fontSize: '16px',
      color: '#888888',
      textAlign: 'center',
    },
  },

  header: {
    width: '100%',
  },

  logo: {
    width: 240,
  },

  podcastInfo: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '5px',
    marginBottom: '10px !important',
  },

  podcastImage: {
    width: 200,
    height: 200,
    borderRadius: 12,
    objectFit: 'cover',
  },

  genreInfo: {
    marginBottom: '16px',
  },

  genreCategory: {
    fontSize: '14px !important',
    textAlign: 'center',
    color: '#46c0ec !important',
    fontWeight: 500,
    fontStyle: 'italic',
  },

  rankChangeDisplay: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  shareButton: {
    width: '14.375rem !important', 
    minWidth: '200px !important', 
    maxWidth: '100% !important',
    color: '#fff !important',
    height: '3.4375rem !important', 
    minHeight: '48px !important', 
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    backgroundPosition: 'center',
    backgroundImage: (props) => `url("${props.bgBtn}")`,
    margin: '0 auto !important',
    padding: '0.5rem 1.25rem !important', 
    fontSize: '1rem !important', 
    lineHeight: '1.2 !important', 
    fontWeight: '700 !important',
    boxSizing: 'border-box !important',
    display: 'flex !important',
    alignItems: 'center !important',
    justifyContent: 'center !important',
    '&:hover': {
      filter: 'brightness(120%)',
      boxShadow: 'none',
      backgroundColor: 'rgba(255, 255, 128, 0)',
      transform: 'scale(1.05) rotate(-2.5deg)',
    },
    [theme.breakpoints.down('sm')]: {
      width: '100% !important',
      minWidth: '280px !important',
      fontSize: '1.1rem !important', 
      padding: '0.75rem 1.5rem !important', 
    },

    [theme.breakpoints.down('xs')]: {
      minWidth: '250px !important',
      height: '3.75rem !important',
      fontSize: '1rem !important',
    },
  },
  podcastArtist: {},
  date: {},
  podcastTitle: {},
  rankDescription: {},
  rankNumber: {},

  [theme.breakpoints.down('sm')]: {
    dialogContent: {
      padding: '24px 16px !important',
    },
  },
}));
